/** Catalogus-zoeken: gedeelde kolomlijst + zoekfilter voor gift_products.
 *
 *  Apart van api.ts gehouden zodat de pure helpers te unit-testen zijn zonder de
 *  Supabase-client (die import.meta.env vereist) mee te trekken.
 */

/** Kolommen die we van gift_products laden. `article_number` = leverancier-sku
 *  (apart van `ean_code` = consument-EAN); nodig om op artikelnummer te zoeken. */
export const GIFT_PRODUCT_FIELDS =
  'id, supplier_id, name, brand, category, product_type, is_packaging, btw_category, unit_purchase_price, vpe, ean_code, article_number, active, source_year, min_order_qty';

export const GIFT_PRODUCT_SELECT = `${GIFT_PRODUCT_FIELDS}, supplier:gift_suppliers(id, name)`;

/** OR-filter voor catalogus-zoeken: naam, brand, EAN én leverancier-artikelnummer.
 *  Mark kan zo "Cosy", "92630" (EAN) of "867" (Reha art.nr) intypen. PostgREST-tekens
 *  die het filter kunnen breken (`%_,()`) worden gestript. */
export function buildProductSearchOr(query: string): string {
  const escaped = query.replace(/[%_,()]/g, '');
  return (
    `name.ilike.%${escaped}%,brand.ilike.%${escaped}%,` +
    `ean_code.ilike.%${escaped}%,article_number.ilike.%${escaped}%`
  );
}

export interface SupplierProductIdentity {
  articleNumber: string | null;
  ean: string | null;
  missingArticleNumber: boolean;
}

/** Houdt het bestelnummer en de barcode expliciet uit elkaar.
 *  Een EAN is bruikbare context, maar nooit een leverancier-artikelnummer. */
export function supplierProductIdentity(product: {
  article_number: string | null;
  ean_code: string | null;
}): SupplierProductIdentity {
  const articleNumber = product.article_number?.trim() || null;
  const ean = product.ean_code?.trim() || null;
  return { articleNumber, ean, missingArticleNumber: articleNumber === null };
}
